var formatId = function formatId(id) {
  return id === null || id === void 0 ? void 0 : id.replace(/\s+/g, '-').toLowerCase();
};
export default formatId;